<template>
  <div class="resume-management">
    <div v-if="profileUpdateLoadingState" class="loader"></div>
    <div v-else>
      <div v-if="isResumeFileUploaded" class="file-uploaded-info">
        <p class="paragraph-bold text-title">{{ labels.currentCV }}</p>
        <p class="paragraph resume-file-name">
          {{ profileDetailsState.resume_file_name }}
        </p>
      </div>
      <div v-else class="no-file-info">
        <p class="paragraph-bold text-title">{{ labels.uploadCV }}</p>
        <p class="paragraph description">{{ labels.uploadCVExplanationText }}</p>
      </div>
      <resume-management-button-container class="has-text-right"></resume-management-button-container>
    </div>
  </div>
</template>

<script>

import 'top20common/distribution/icons/edit';
import 'top20common/distribution/icons/plus';

import {mapGetters} from 'vuex';

import ResumeManagementButtonContainer from './ResumeManagementButtonContainer';

export default {
  computed: {
    ...mapGetters(['profileDetailsState', 'profileUpdateLoadingState', 'isResumeFileUploaded']),
    labels() {
      return {
        uploadCV: this.$gettext('Upload CV'),
        uploadCVExplanationText: this.$gettext('Upload your CV to fill out your profile automatically'),
        currentCV: this.$gettext('Current CV')
      };
    }
  },
  components: {
    ResumeManagementButtonContainer
  }
};
</script>

<style lang="scss" scoped>
.resume-management {
  .text-title {
    min-width: 85px;
  }

  .resume-file-name {
    display: block;
    word-break: break-all;
  }
}
</style>
